
/**
 * App.js Layout Start Here
 */

import { Error } from '@progress/kendo-react-labels';
import { MaskedTextBox } from "@progress/kendo-react-inputs";
import { MaskFormatted } from '../../helper/mask-helper'


function ZipCodeOpt({ name, value, onChange, label, error, placeholder, validityStyles, required,
    className
}) {

    let mask = '9999'
    let maskedValue = MaskFormatted(value, mask)

    return (
        < >

            <MaskedTextBox
                name={name}
                defaultValue={maskedValue}
                onChange={onChange}
                label={label}
                placeholder={placeholder}
                validityStyles={validityStyles}
                required={required}
                mask={mask}
                includeLiterals={false}
                className={className}
            />
            {
                error &&
                <Error >
                    {error}
                </Error>
            }
        </>


    );

}
export default ZipCodeOpt;

